import { render, staticRenderFns } from "./ContactTabUnderConstruction.vue?vue&type=template&id=8d262d06&scoped=true"
import script from "./ContactTabUnderConstruction.vue?vue&type=script&lang=js"
export * from "./ContactTabUnderConstruction.vue?vue&type=script&lang=js"
import style0 from "./ContactTabUnderConstruction.vue?vue&type=style&index=0&id=8d262d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d262d06",
  null
  
)

export default component.exports